import { createFileRoute, notFound, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/SlideWizard'
import { getChapterBySlug, getNextChapterSlug } from '@/lib/chapters'

export const Route = createFileRoute('/basics/$basicsSlug/start')({
  beforeLoad: ({ params }) => {
    if (!getChapterBySlug(params.basicsSlug)) throw notFound()
  },
  component: ChapterPlayer,
})

function ChapterPlayer() {
  const { basicsSlug } = Route.useParams()
  const navigate = useNavigate()
  const entry = getChapterBySlug(basicsSlug)
  if (!entry) return null

  const next = getNextChapterSlug(basicsSlug)

  return (
    <SlideWizard
      chapter={entry.chapter}
      onExit={() => navigate({ to: '/basics/$basicsSlug', params: { basicsSlug } })}
      onComplete={() => {
        if (next) {
          navigate({ to: '/basics/$basicsSlug', params: { basicsSlug: next } })
        } else {
          navigate({ to: '/basics' })
        }
      }}
    />
  )
}
